import React, {Component} from 'react';

import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import _ from 'lodash';
import {withSnackbar} from 'notistack';
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import {Typography} from "@material-ui/core";
import PlaylistList from "./PlaylistList";
import TextField from "@material-ui/core/TextField";
import ThumbnailUploader from "./ThumbnailUploader";
import PlaylistMomentClips from "./PlaylistMomentClips";
import Button from "@material-ui/core/Button";
import MomentService from "../Services/MomentsService";
import ClipMomentSearch from "./MomentClipSearch";
import showSnackBar from "../Utilities/SnackbarHelper";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import {ERROR, SUCCESS, WARNING} from "../constants";
import {handleReOrder} from "../Utilities/List";
import {capitalizeFirstLetter} from "../Utilities/StringUtils"
import Competition from "./Competition";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import ReactGA from 'react-ga';
import {MOMENTS_PLAYLISTS, EDIT_MOMENT_PLAYLIST , DELETE_MOMENT_PLAYLIST ,CREATE_NEW_PLAYLIST, UPLOAD_THUMBNAIL, SAVE_MOMENT_PLAYLIST, MOMENT_CHAMPIONSHIP, 
    REORDER_MOMENT_PLAYLIST, DELETE_CLIP_FROM_MOMENT_PLAYLIST} from '../Utilities/GAUtils';

const styles = theme => ({
    container: {
        position: 'relative',
        minHeight: "100vh"
    },
    searchBar: {
        flex: 1
    },
    playlistClipMomentsContainer: {
        minHeight: "30vh"
    },
    formTitle: {},
    momentIdInput: {
        marginTop: "-13px"
    },
    thumbnailContainerCard: {
        display: "inline",
        marginRight: theme.spacing(1)
    }
});


class Playlist extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mode: 'list',
            momentsPlaylists: null,
            title: '',
            thumbnails: [],
            momentClips: [],
            tags: '',
            momentClipId: '',
            inputSearchText: '',
            playlistIdToDelete:'',
            deleteDialogOpen : false,
            momentPlaylistId : ''
        };

        this.handleSuggestionSelect = this.handleSuggestionSelect.bind(this);
    }


    componentDidMount() {
        this.loadAllMomentsPlaylists();
    }

    loadAllMomentsPlaylists() {
        let self = this;
        MomentService.getMomentsPlaylists().then((response) => {
            if (response && response.data && response.data.entity && response.data.entity.length > 0) {
                self.setState({momentsPlaylists: response.data.entity});
            } else {
                if (response && response.data && (response.data.responseType === "SUCCESS")) {
                    self.setState({momentsPlaylists: response.data.entity});
                }
            }
        });
    }

    loadMomentsPlaylist(id) {
        let self = this;
        MomentService.getMomentsPlaylist(id).then((response) => {
            if (response && response.data && response.data.entity) {
                self.setState({
                    id: response.data.entity.id,
                    title: response.data.entity.title,
                    thumbnails: response.data.entity.thumbnails,
                    momentClips: response.data.entity.momentClips,
                    tags: response.data.entity.tags
                });
            }
        })
    }

    handleChangePosition = index => event => {
        let newMomentClips = this.state.momentClips;

        newMomentClips[index].position = event.target.value;
        this.setState(newMomentClips);
    };

    saveMomentsPlaylist(event) {

        let self = this;
        if (event) {
            event.preventDefault();
        }

        let momentClips = this.state.momentClips;

        // Object.freeze(momentClips);

        let momentsPlaylistToSave = {
            id: this.state.id,
            title: this.state.title,
            thumbnails: this.state.thumbnails,
            momentClips: momentClips,
            tags: this.state.tags,
        };

        let momentsServiceToUse = null;
        console.log(this.state.id);
        if (this.state.id) {
            momentsServiceToUse = MomentService.saveMomentsPlaylist(momentsPlaylistToSave);
        } else {
            delete momentsPlaylistToSave.id;
            momentsServiceToUse = MomentService.createMomentsPlaylist(momentsPlaylistToSave);
        }
        momentsServiceToUse.then((response) => {
            if (response.data.responseType === "SUCCESS") {
                showSnackBar("Moments playlist saved successfully!", SUCCESS, self);
                self.setState({mode: 'edit'});
                self.loadMomentsPlaylist(response.data.entity.id);
                self.loadAllMomentsPlaylists();

            } else {
                let errorMessages = "";
                if (response.data.genericMessage && response.data.genericMessage.ERROR) {
                    errorMessages = errorMessages + response.data.genericMessage.ERROR.join(". ");
                }
                showSnackBar(`Moments playlist can not be saved. ${errorMessages}`, ERROR, self);
            }
        });

        ReactGA.ga('send','event',
                MOMENTS_PLAYLISTS,
                SAVE_MOMENT_PLAYLIST,
                this.state.momentPlaylistId,
                1)
    }


    componentWillUnmount() {

    }

    handleChange = element => event => {

        if (event) {
            event.preventDefault();
        }
        this.setState({
            [element]: event.target.value,
        }, function () {

        });
    };

    handleSuggestionSelect(momentClipId, momentClip) {
        let self = this;

        let momentClips = this.state.momentClips;

        let newMomentClips = [];

        newMomentClips = this.addMomentClip(momentClip, momentClips, self);

        self.setState({momentClips: newMomentClips});
    }

    handleAddMomentClipById(event) {


        if (event.key === 'Enter') {
            event.preventDefault();
            this.setState({inputSearchText: "toClearInputSearchText"});
            let momentClipId = event.target.value;
            let newMomentClips = [];
            let momentClips = this.state.momentClips;
            let self = this;
            if (momentClipId) {
                MomentService.getMomentClip(momentClipId).then((response) => {
                    let momentClip = response.data.entity;
                    if (momentClip) {
                        newMomentClips = this.addMomentClip(momentClip, momentClips, self);
                        self.setState({momentClips: newMomentClips});
                    } else {
                        showSnackBar("Invalid moment ID.", ERROR, self);
                        console.log(response);
                    }

                })
            }
        }

    }

    addMomentClip(momentClip, momentClips, context) {

        let ifExist = function (element) {
            return element.momentClip.id === momentClip.id;
        };

        let newMomentClips = [];
        if (momentClips) {
            if (!momentClips.some(ifExist)) {

                let momentClipToAdd = {};
                momentClipToAdd.momentClip = momentClip;
                let maxPosition = Math.max.apply(Math, momentClips.map(function (clm) {
                    return clm.position;
                }));

                if (maxPosition == "-Infinity") {
                    maxPosition = 0;
                }

                momentClipToAdd.position = maxPosition + 1;
                momentClips.unshift(momentClipToAdd);

                newMomentClips = momentClips;
            } else {
                showSnackBar("Can't add same moment again.", WARNING, context);
                newMomentClips = momentClips;
            }
        } else {
            let momentClipToAdd = {};
            let momentClips = [];
            momentClipToAdd.momentClip = momentClip;
            momentClipToAdd.position = 1;
            momentClips[0] = momentClipToAdd;

            newMomentClips = momentClips;
        }

        return newMomentClips;
    }

    openCompetition() {
        this.setState({
            mode: 'competition',
            title: '',
            thumbnails: [],
            momentClips: [],
            tags: '',
            momentClipId: ''
        });
        ReactGA.ga('send','event',
                MOMENTS_PLAYLISTS,
                MOMENT_CHAMPIONSHIP,
                '',
                1)
    }

    handleEdit(momentsPlaylistId) {
        let mode = "edit";
        this.setState(
            {
                mode: mode, title: '',
                thumbnails: [],
                momentClips: [],
                tags: '',
                momentClipId: '',
                momentPlaylistId: momentsPlaylistId
            }
        );
        this.loadMomentsPlaylist(momentsPlaylistId);
        ReactGA.ga('send','event',
                MOMENTS_PLAYLISTS,
                EDIT_MOMENT_PLAYLIST,
                momentsPlaylistId,
                1)
    }

    confirmDelete(playlistIdToDelete){
        this.setState({playlistIdToDelete:playlistIdToDelete,deleteDialogOpen:true});
    }

    closeDeleteForm(){
        this.setState({playlistIdToDelete:'',deleteDialogOpen:false});
    }
    deletePlaylist() {
        let self = this;
        if(this.state.playlistIdToDelete!==''){
            MomentService.deleteMomentsPlaylist(this.state.playlistIdToDelete).then((response) => {
                if (response && response.data && (response.data.responseType === "SUCCESS")) {
                    self.setState({deleteDialogOpen:false});
                    showSnackBar("Moments playlist deleted successfully.", SUCCESS, self);
                    self.loadAllMomentsPlaylists();
                } else {
                    let errorMessages = "";
                    if (response.data.genericMessage && response.data.genericMessage.ERROR) {
                        errorMessages = errorMessages + response.data.genericMessage.ERROR.join(". ");
                    }
                    showSnackBar(`Moments playlist could not be deleted. ${errorMessages}`, ERROR, self);
                }
            })
        }else{
            console.log(this.state);
        }
        ReactGA.ga('send','event',
                MOMENTS_PLAYLISTS,
                DELETE_MOMENT_PLAYLIST,
                this.state.playlistIdToDelete,
                1)
    }

    removeMomentClip(momentClipId) {

        let self = this;
        // let momentClipToDelete = _.filter(this.state.momentClips, (momentClip)=>{
        //     return momentClip.id === momentClipId
        // } )[0];

        let momentClipRecord = [
            {
                "momentsId": this.state.id,
                "momentClipsId": momentClipId
            }
        ];

        MomentService.removeMomentClipFromPlaylist(momentClipRecord).then((response) => {
            if (response.data.responseType === "SUCCESS") {
                showSnackBar("Clip moment removed successfully!", SUCCESS, self);
                self.setState({mode: 'edit'});
                self.loadMomentsPlaylist(self.state.id);
                self.loadAllMomentsPlaylists();

            } else {
                let errorMessages = "";
                if (response.data.genericMessage && response.data.genericMessage.ERROR) {
                    errorMessages = errorMessages + response.data.genericMessage.ERROR.join(". ");
                }
                showSnackBar(`Clip moment can not be saved. ${errorMessages}`, ERROR, self);
            }
        });

        ReactGA.ga('send','event',
                MOMENTS_PLAYLISTS,
                DELETE_CLIP_FROM_MOMENT_PLAYLIST,
                this.state.id,
                1)
    }

    onDragDropPosition(event) {
        let momentClipOrderedIDs = event;
        let momentClips = this.state.momentClips;
        let newMomentClips = this.handleReOrderMomentClips(momentClipOrderedIDs,momentClips,'id');
        this.setState({momentClips: newMomentClips});
        ReactGA.ga('send','event',
                MOMENTS_PLAYLISTS,
                REORDER_MOMENT_PLAYLIST,
                this.state.momentPlaylistId,
                1)
    }

    handleReOrderMomentClips(newOrderedIDs, list, identifier) {
        let newList = [];
        let position = list.length;
        if(newOrderedIDs && newOrderedIDs.length>0){
            newOrderedIDs.map(orderedId => {
                _.map(list,(listElement => {
                    // console.log(`orderID - ${orderedId}, momentclipid - ${listElement.momentClip.id}`)
                    if (orderedId == listElement.momentClip[identifier]) {
                        let newListItemToPush = {};
                        newListItemToPush = listElement;
                        newListItemToPush.position = position;
                        position = position - 1;
                        newList.push(newListItemToPush);
                    }
                }));
            });
        }else{
            newList = list;
        }
        return newList
    }

    handleCreate(event) {
        let self = this;
        let mode = "create";
        this.setState({

                mode: mode,
                id: '',
                title: '',
                thumbnails: [],
                momentClips: [],
                tags: '',
                momentClipId: ''
            },
            () => {

            });
            ReactGA.ga('send','event',
                    MOMENTS_PLAYLISTS,
                    CREATE_NEW_PLAYLIST,
                    '',
                    1)
    }

    updateThumbnails(url) {
        let thumbnails = this.state.thumbnails;
        let thumbnailToAdd = {
            "contentType": "MOMENTS",
            "sourceUrl": url,
            "aspectRatio": "16x9"
        };
        if (thumbnails && thumbnails.length > 0) {
            thumbnails.push(thumbnailToAdd);
        } else {
            thumbnails = [];
            thumbnails[0] = thumbnailToAdd;
        }
        this.setState({thumbnails: thumbnails});
        ReactGA.ga('send','event',
                MOMENTS_PLAYLISTS,
                UPLOAD_THUMBNAIL,
                this.state.momentPlaylistId,
                1)
    };

    closeForm() {
        this.setState({
            mode: 'list',
            title: '',
            thumbnails: [],
            momentClips: [],
            tags: '',
            momentClipId: ''
        });
    }

    closeCompetition() {
        this.setState({
            mode: 'list',
            title: '',
            thumbnails: [],
            momentClips: [],
            tags: '',
            momentClipId: ''
        });
    }

    render() {

        const {classes, theme} = this.props;

        let formTitle = `${this.state.mode} Moments Playlist`;
        if (this.state.mode === "edit") {
            formTitle = `${formTitle} with ID ${this.state.id}`
        }
        formTitle = capitalizeFirstLetter(formTitle);

        return <React.Fragment>


            {((this.state.mode === "create") || (this.state.mode === "edit")) &&
            <Card>
                <CardHeader className={classes.formTitle} title={formTitle}
                            action={
                                <IconButton aria-label="delete" onClick={this.closeForm.bind(this)}>
                                    <CloseIcon fontSize="small"/>
                                </IconButton>
                            }/>
                <CardContent>
                    <form onSubmit={this.saveMomentsPlaylist.bind(this)}>


                        <Grid container spacing={0}>
                            <Grid item xs={3}></Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth required
                                           id="title" onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                        event.preventDefault()
                                    }
                                }}
                                           label="Moments Playlist Title"
                                           className={classes.titleInput}
                                           value={this.state.title}
                                           onChange={this.handleChange('title')}
                                           margin="normal"
                                />
                            </Grid>
                            <Grid item xs={3}>

                            </Grid>
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={3}></Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                        event.preventDefault()
                                    }
                                }}
                                           id="tags"
                                           label="Tags"
                                           placeholder={"e.g. fun,comedy"}
                                           className={classes.titleInput}
                                           onChange={this.handleChange('tags')}
                                           value={this.state.tags}
                                           margin="normal"
                                />
                            </Grid>
                            <Grid item xs={3}>

                            </Grid>
                        </Grid>


                        <br/>

                        <Grid container spacing={0}>
                            <Grid item xs={3}></Grid>
                            <Grid item xs={6}>
                                <Typography variant={"body1"}>Playlist Thumbnail</Typography>
                                <br/>
                                <Paper>

                                    <Typography variant={"body2"}>Uploaded Thumbnails</Typography>
                                    {this.state.thumbnails && this.state.thumbnails.length > 0 &&
                                    _.map(this.state.thumbnails, (thumbnail, index) => {
                                        if (thumbnail.id) {
                                            return (<Card className={classes.thumbnailContainerCard} key={index}>
                                                <a href={thumbnail.sourceUrl.replace("http://ctool0.blueapple.mobi:8099/","https://storage.googleapis.com/lcontent.vuclip.com/")}
                                                   target="_blank" rel="noopener noreferrer">
                                                    <img src={thumbnail.sourceUrl.replace("http://ctool0.blueapple.mobi:8099/","https://storage.googleapis.com/lcontent.vuclip.com/")} height={"112"} width={"200"}></img>
                                                </a>
                                            </Card>)
                                        }

                                    })
                                    }
                                    <ThumbnailUploader updateThumbnails={this.updateThumbnails.bind(this)}
                                                       label={"Drag & Drop / Browse Thumbnail File here to upload new or replace"}
                                                       files={this.state.thumbnails} type={'moments'} inputName={'MOMENTS16x9'}/>
                                </Paper>
                            </Grid>
                            <Grid item xs={3}></Grid>
                        </Grid>
                        <br/>
                        <div className={classes.playlistClipMomentsContainer}>
                            <Grid container spacing={0}>
                                <Grid item xs={3}></Grid>
                                <Grid item xs={6}>
                                    <Typography variant={"body1"}>Add Clip Moments</Typography>
                                    <Grid container>
                                        <Grid item xs={7}>
                                            <ClipMomentSearch inputSearchText={this.state.inputSearchText}
                                                              handleSuggestionSelect={this.handleSuggestionSelect.bind(this)}/>
                                        </Grid>
                                        <Grid item xs={1}>
                                            <Typography variant={"body2"}>
                                                OR
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <TextField
                                                id="momentId" onKeyDown={this.handleAddMomentClipById.bind(this)}
                                                className={classes.momentIdInput}
                                                label="Enter a Moment Clip ID"
                                                value={this.state.momentClipId}
                                                onChange={this.handleChange('momentClipId')}
                                                placeholder={"e.g. 42"}
                                                margin="normal"
                                            />
                                        </Grid>


                                    </Grid>

                                </Grid>
                                <Grid item xs={3}></Grid>
                            </Grid>
                            <Grid container spacing={0}>
                                <Grid item xs={1}></Grid>
                                <Grid item xs={10}>
                                    <PlaylistMomentClips momentClips={this.state.momentClips}
                                                         removeMomentClip={this.removeMomentClip.bind(this)}
                                                         onChange={this.onDragDropPosition.bind(this)}/>
                                </Grid>
                                <Grid item xs={1}></Grid>
                            </Grid>
                            <br/>
                        </div>

                        <Grid container justify="space-around"
                              alignItems="center" spacing={0}>

                            <Grid item xs={2}>
                                <Button fullWidth variant="contained" type="submit" color="primary"
                                        className={classes.button}>
                                    Save Playlist
                                </Button>
                            </Grid>

                        </Grid>
                        <br/>
                    </form>
                </CardContent>
            </Card>
            }

            {((this.state.mode === "competition")) &&
                <Competition mode={"momentPlaylists"} closeCompetition={this.closeCompetition.bind(this)}/>
            }

            {(this.state.deleteDialogOpen === true) &&
            <Dialog
                open={this.state.deleteDialogOpen}
                onClose={this.closeDeleteForm.bind(this)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{`Delete moments playlist with ID ${this.state.playlistIdToDelete}?`}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        This moments playlist will be permanently deleted from the system and can not be recovered.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.closeDeleteForm.bind(this)} color="default" autoFocus>
                        No
                    </Button>
                    <Button onClick={this.deletePlaylist.bind(this)} variant={"contained"} color="secondary">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
            }

            <PlaylistList momentsPlaylists={this.state.momentsPlaylists}
                          openCompetition={this.openCompetition.bind(this)}
                          deletePlaylist={this.confirmDelete.bind(this)}
                          handleEdit={this.handleEdit.bind(this)}
                          handleCreate={this.handleCreate.bind(this)}/>


        </React.Fragment>
    }
}


Playlist.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};


export default (withStyles(styles, {withTheme: true})(withSnackbar(Playlist)));
